import { render, staticRenderFns } from "./UserInfoPhone.vue?vue&type=template&id=5ae2ada3&scoped=true&"
import script from "./UserInfoPhone.vue?vue&type=script&lang=js&"
export * from "./UserInfoPhone.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoPhone.vue?vue&type=style&index=0&id=5ae2ada3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2ada3",
  null
  
)

export default component.exports